import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userId: 11,
        userName: null
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
})
